import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import Button from '@material-ui/core/Button';
import SectionHeader from '../SectionHeader';
import SectionChapter from '../SectionChapter';
import AIAssistantStateIcon from '../../../MyComponents/AIAssistant/AIAssistantStateIcon';
import MathConvertorManagement from './AiAssistantSections/MathConvertorManagement';

const PREFIX = 'redesign.page.tutorial.manageLesson.aiAssistant.';
const bold = { b: (chunks) => <b>{chunks}</b> };

const Line = ({ id, children }) => (
    <li>
        <Typography>
            <FormattedMessage id={PREFIX + id} values={bold} />
        </Typography>
        {children}
    </li>
);

/**
 * The AI section: generating content, choosing where it lands, cleaning up the
 * handwriting on the board, and the maths formula converter.
 */
const AiAssistant = ({ language, classes, refs }) => {
    const img = (name) => `/static/asset/img/tutorial/withText/${language.toUpperCase()}/${name}.jpeg`;

    const generateSet = [
        {
            id: PREFIX + 'explanation1',
            children: (
                <ul>
                    <Line id="line0">
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            startIcon={<AIAssistantStateIcon state="idle" size={22} />}
                        >
                            <FormattedMessage id="menu.aiExercise" />
                        </Button>
                    </Line>
                    <Line id="line1" />
                    <Line id="line2" />
                    <Line id="line3" />
                    <Line id="line4" />
                    <Line id="line5" />
                    <Line id="line6" />
                </ul>
            ),
            img: [img('ai_assistant_open')],
        },
    ];

    const destinationSet = [
        {
            id: PREFIX + 'explanation2',
            children: (
                <ul>
                    <Line id="dest0" />
                    <Line id="dest1" />
                    <Line id="dest2" />
                </ul>
            ),
            img: [img('ai_assistant_students')],
        },
    ];

    const tidySet = [
        {
            id: PREFIX + 'explanation3',
            children: (
                <ul>
                    <Line id="tidy0" />
                    <Line id="tidy1" />
                    <Line id="tidy2" />
                    <Line id="tidy3" />
                </ul>
            ),
            img: [img('ai_assistant_tidy'), img('ai_assistant_tidy_done')],
        },
    ];

    return (
        <>
            <SectionHeader
                refs={refs}
                title={'tutorial.aiAssistant.title'}
                description={'tutorial.aiAssistant.description'}
                id={'section-aiAssistant'}
            />
            <SectionChapter
                refs={refs}
                id={'section-aiAssistant-generate'}
                title={'tutorial.aiAssistant.generate.title'}
                explanations={generateSet}
                imageTop={false}
            />
            <SectionChapter
                refs={refs}
                id={'section-aiAssistant-destination'}
                title={'tutorial.aiAssistant.destination.title'}
                explanations={destinationSet}
                imageTop={false}
            />
            <SectionChapter
                refs={refs}
                id={'section-aiAssistant-tidy'}
                title={'tutorial.aiAssistant.tidy.title'}
                explanations={tidySet}
                imageTop={false}
            />
            <MathConvertorManagement language={language} classes={classes} refs={refs} />
        </>
    );
};

export default AiAssistant;
